import React from 'react';
import { Observe } from 'rewire-core';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import InfoPanel, { IInfoPanelProps } from '../ui/InfoPanel';
import InfoPanelHeader from '../ui/InfoPanelHeader';
import InfoPanelContent from '../ui/InfoPanelContent';
import InfoPanelFooter from '../ui/InfoPanelFooter';
import DefaultEditPanelFormView from './DefaultEditPanelFormView';
import { If } from './SettingsModel';
import { RolePermissionDialogModel } from './RolePermissionDialogModel';
import RolesSettingsModel from './RolesSettingsModel';
import SettingsModel from './SettingsModel';

const useEditPanelViewStyles = makeStyles((_theme) => ({
  infoPanelRoot: {},
}));

const RolePermissionSettingsEditPanelView = ({
  settings,
  InfoPanelProps,
}: { settings: SettingsModel; InfoPanelProps?: IInfoPanelProps }) => {
  if (!settings.editor) return null;

  const roleSettingsModel = settings as RolesSettingsModel;
  const classes = useEditPanelViewStyles();
  const editor = roleSettingsModel.editor as RolePermissionDialogModel;
  return (
    <Observe
      render={() => {
        const hasSelectionAndNotChecked = !roleSettingsModel.hasCheckedItems && roleSettingsModel.selectedItem;

        return (
          <InfoPanel {...InfoPanelProps} classes={{ infoPanelRoot: classes.infoPanelRoot }}>
            <InfoPanelHeader
              title={`${(hasSelectionAndNotChecked && roleSettingsModel.editor?.title) || RolePermissionDialogModel.title}`}
              tabs={hasSelectionAndNotChecked ? editor.viewTabs : undefined}
              optionsItems={settings.getDefaultEditPanelHeaderOptionsItems()}
            />
            <If
              condition={!roleSettingsModel.hasCheckedItems}
              then={
                <>
                  <InfoPanelContent>
                    {roleSettingsModel.selectedItem ? (
                      <DefaultEditPanelFormView editor={roleSettingsModel.editor! as RolePermissionDialogModel} />
                    ) : null}
                  </InfoPanelContent>
                  {roleSettingsModel.selectedItem && (
                    <InfoPanelFooter isDisabled={roleSettingsModel.editor!.isDisabled} actions={roleSettingsModel.footerActions} />
                  )}
                </>
              }
              otherwise={
                <InfoPanelContent>
                  <Typography variant="h6" style={{ margin: 'auto', paddingBottom: '43px' }}>
                    «multiple users selected»
                  </Typography>
                </InfoPanelContent>
              }
            />
          </InfoPanel>
        );
      }}
    />
  );
};

RolePermissionSettingsEditPanelView.defaultProps = {
  InfoPanelProps: {
    defaultSize: {
      width: 400,
      height: '100%',
    },
    minWidth: 400,
  },
};

export default RolePermissionSettingsEditPanelView;
